export const Chevron = ({
	direction,
	size,
}: {
	direction: "up" | "down" | "left" | "right";
	size?: "md" | "xl";
}) => {
	const rotation =
		direction === "up" ? 180 : direction === "down" ? 0 : direction === "left" ? 90 : 270;
	if (size === "xl")
		return (
			<svg
				width="32"
				height="32"
				viewBox="0 0 32 32"
				fill="none"
				style={{
					transform: `rotate(${rotation}deg)`,
				}}
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M23.5 13L16 20.5L8.5 13"
					stroke="#0E0E0E"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		);

	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			style={{
				transform: `rotate(${rotation}deg)`,
			}}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 6L8 10L4 6"
				stroke="#0E0E0E"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
